import { getBirthdayMonthsOffest } from '../../service/dateUtil';
import SummaryItemDetailsRow from './SummaryItemDetailsRow'
import { useState } from 'react'
export default function SummaryItemDonation({ kid }) {
    const [minimize, setMinimze] = useState(true)

    const { name, plan, age, marriage, units, grantFirstUnit, stockMarket,birthday } = kid;

    const monthsWait = (marriage - age) * 12 - plan?.monthsSave + getBirthdayMonthsOffest(birthday, age);

    const grantType = (grantFirstUnit) ? "מענק מלא על היחידה הראשונה" : "רגיל - בסיום ההלוואה";

    const handleMinimize = (e) => {
        setMinimze(prev => !prev)
    }

    const handleKeyDown = (e) => {
        if ([13, 32].includes(e.keyCode)) {
            e.preventDefault();
            setMinimze(prev => !prev)

        }
    }

    return (
        <div className="summary-item" onClick={handleMinimize} tabIndex={0} onKeyDown={handleKeyDown}>
            <div className="summary-item-wrapper" >
                <div className="summary-item-header">
                    <span>{name}
                        {/* {(familyGrant) ? <span className='recive-grant-tag' >מימוש מענק משפחתי</span> : <></>} */}
                    </span>
                    <div className="item-value-wrapper">
                        <span className="value"><span className="shekel-mrk">₪</span>{plan?.monthlyPay * Number(units)}</span>
                        <span className="label">תרומה חודשית</span>
                    </div>
                </div>
                <img className={`item-minimize ${(minimize) && 'minimized'}`} src="./icons/chevron-up.svg" alt='⌃' />
            </div>
            <div className="summary-item-details">
                <SummaryItemDetailsRow label="חודשי תרומה" type="text" value={plan?.monthsSave} />
                {/* <SummaryItemDetailsRow label="שנות תרומה" type="text" value={Math.round(plan?.monthsSave / 12)} /> */}
                <SummaryItemDetailsRow label="סך התרומה" value={plan?.totalPay * units} />
                <SummaryItemDetailsRow label="זמן המתנה מסיום תרומה עד לקבלת הלוואה" type="text" value={(monthsWait > 0) ? monthsWait : 0} >חודשים</SummaryItemDetailsRow>
                <SummaryItemDetailsRow label="החזר חודשי" value={plan?.monthlyReturn * units} />
                <SummaryItemDetailsRow label="גובה הלוואה" value={plan?.loan * units} />
                {/* <SummaryItemDetailsRow label="סוג המענק" type="text" value={grantType} /> */}
                {/* <SummaryItemDetailsRow label="גובה מענק" type='percent' value={Math.round(plan.return *100 / plan.totalPay)} /> */}
                < SummaryItemDetailsRow label="סכום מענק" value={plan?.return * units} />
                {(!!stockMarket) && <div className="summary-stock-market">
                    <SummaryItemDetailsRow label='סה"כ רווח עד החתונה' value={stockMarket?.totalPrfit} />
                    <SummaryItemDetailsRow label='מיסוי צפוי על הרווח (25%)' value={stockMarket?.profitVat} />
                    <SummaryItemDetailsRow label='סה"כ לחתונה (הפקדה + רווח)' value={stockMarket?.totalForWedding} />
                    <SummaryItemDetailsRow label='סה"כ השלמה מהלוואות בנקאיות' value={stockMarket?.completeWithLoan} />
                    <SummaryItemDetailsRow label='תשלום ריבית' value={stockMarket?.loanInterest} />
                    <SummaryItemDetailsRow label='החזר חודשי בהלוואה בנקאית' value={stockMarket?.loanMonthlyPayment} />
                    <SummaryItemDetailsRow label='סה"כ הוצאות במסלול שוק ההון' value={stockMarket?.totalPayment} />
                    <SummaryItemDetailsRow label='סה"כ הוצאות בגמ"ח' value={stockMarket?.totalGLBpayment} />
                    <SummaryItemDetailsRow label='חיסכון במסלול הגמ"ח' value={stockMarket?.totalDiff} />
                </div>}
            </div>
        </div>
    )
}
